var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_112_229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.4372 9.63059C43.7647 7.91225 39.8795 6.69129 35.8842 6C35.3865 6.89972 34.8051 8.10984 34.4041 9.07256C30.0965 8.42484 25.8285 8.42484 21.6 9.07256C21.1993 8.11006 20.6047 6.89972 20.1025 6C16.1033 6.69161 12.2147 7.91568 8.54042 9.63956C1.22892 20.6884 -0.753172 31.4625 0.237766 42.0841C5.08724 45.7055 9.78686 47.9055 14.4073 49.3451C15.5556 47.766 16.5707 46.0941 17.442 44.3469C15.7831 43.7153 14.1838 42.937 12.6632 42.0211C13.0634 41.7245 13.4541 41.4154 13.8348 41.0943C23.049 45.4041 33.0608 45.4041 42.1651 41.0943C42.5475 41.4133 42.9381 41.7224 43.3365 42.0211C41.8135 42.9394 40.2113 43.7193 38.549 44.3515C39.4253 46.1058 40.4385 47.7793 41.5837 49.3495C46.2085 47.9101 50.9125 45.7101 55.762 42.0841C56.9249 29.7711 53.7757 19.0959 47.4372 9.63059ZM18.6974 35.552C15.9313 35.552 13.6629 32.9697 13.6629 29.8252C13.6629 26.6806 15.883 24.0939 18.6974 24.0939C21.5121 24.0939 23.7803 26.676 23.732 29.8252C23.7363 32.9697 21.5121 35.552 18.6974 35.552ZM37.3023 35.552C34.5362 35.552 32.268 32.9697 32.268 29.8252C32.268 26.6806 34.4879 24.0939 37.3023 24.0939C40.117 24.0939 42.3852 26.676 42.3369 29.8252C42.3369 32.9697 40.117 35.552 37.3023 35.552Z",
    fill: "#5865F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_112_229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscordIcon);
export default __webpack_public_path__ + "static/media/discord-icon.2e62b5eac64d2f54bf01b34ad0cfe41d.svg";
export { ForwardRef as ReactComponent };